import React from 'react';
import { Document, Folder } from '../types/documents';
import { DocumentRow } from './DocumentRow';
import { FolderRow } from './FolderRow';
interface DocumentListProps {
  documents: Document[];
  folders?: Folder[];
  onViewDocument: (doc: Document) => void;
  isSearching?: boolean;
  onMoveDocument?: (docId: string, folderId: string | undefined) => void;
}
export function DocumentList({
  documents,
  folders = [],
  onViewDocument,
  isSearching = false,
  onMoveDocument
}: DocumentListProps) {
  // If searching, show flat list of all matching documents
  if (isSearching) {
    return <div className="flex flex-col w-full max-h-[800px] overflow-y-auto custom-scrollbar" data-id="element-3">
        {documents.map(doc => <DocumentRow key={doc.id} document={doc} onView={onViewDocument} folders={folders} onMoveDocument={onMoveDocument} data-id="element-4" />)}
      </div>;
  }
  // Otherwise, show folders and ungrouped documents
  const ungroupedDocuments = documents.filter(doc => !doc.folderId);
  return <div className="flex flex-col w-full max-h-[800px] overflow-y-auto custom-scrollbar" data-id="element-5">
      {/* Render Folders */}
      {folders.map(folder => <FolderRow key={folder.id} folder={folder} documents={documents} folders={folders} onViewDocument={onViewDocument} onMoveDocument={onMoveDocument} data-id="element-6" />)}

      {/* Render Ungrouped Documents */}
      {ungroupedDocuments.map(doc => <DocumentRow key={doc.id} document={doc} onView={onViewDocument} folders={folders} onMoveDocument={onMoveDocument} data-id="element-7" />)}
    </div>;
}